import EventRsvpNoteDetail from '@/screens/EventRsvpNoteDetail';

export default function PrivateEventEventIdRsvpNotePersonIdRoute() {
  return <EventRsvpNoteDetail />;
}
